// Toyo Team configuration - Business & Teambuilding
import { AppConfig } from './types';
import { teamTheme } from './themes';
import { TEAM_GAMES } from './games';

export const teamConfig: AppConfig = {
  // App identity
  appId: 'team',
  appName: 'Toyo Team',
  appTagline: 'Learn. Laugh. Lead.',
  
  // Branding
  logo: '/assets/toyo-team-logo.png',
  homeUrl: 'https://toyo.games/teambuilding',
  
  // Theme
  theme: teamTheme,
  
  // Games - Team has business and IT-focused games
  games: TEAM_GAMES,
  
  // Feature flags
  features: {
    voting: true,
    hostPlaying: true,
    settings: true,
  },
  
  // Storage prefix
  storagePrefix: 'toyo-team',
  
  // SEO and metadata
  seo: {
    title: 'Toyo Team - Business & Team Building Games | team.toyo.games',
    description: 'Professional team building games for businesses. Agile Quiz, Tech Trivia, Business Brain Teasers, and more. Perfect for corporate events, team building, onboarding, and office fun. Learn, laugh, and lead together!',
    keywords: [
      'toyo team',
      'team building games',
      'business games',
      'corporate games',
      'agile quiz',
      'tech trivia',
      'business brain teasers',
      'team building activities',
      'corporate team building',
      'office games',
      'workplace games',
      'professional games',
      'scrum quiz',
      'kanban quiz',
      'IT trivia',
      'business trivia',
      'team building events',
      'corporate events',
      'onboarding games',
    ],
    ogTitle: 'Toyo Team - Learn. Laugh. Lead.',
    ogDescription: 'Professional team building games for businesses. Agile Quiz, Tech Trivia, and Business Brain Teasers. Perfect for corporate events!',
    ogImage: '/assets/toyo-team-logo.png',
    ogUrl: 'https://team.toyo.games',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Toyo Team - Learn. Laugh. Lead.',
    twitterDescription: 'Professional team building games for businesses. Perfect for corporate events!',
    twitterImage: '/assets/toyo-team-logo.png',
  },
};
